import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const liveAuctionApi = createApi({
  reducerPath: reducerPaths.liveAuctionApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    setDealerBidPrice: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `/dealer/dealerbidprice`,
          body: payload
        }
      }
    }),
    cancelAuction: builder.mutation({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/cancel-auction/${Vehicle_Id}`,
          method: "POST"
        }
      }
    }),
    getOwnLiveAuctionVehicles: builder.query({
      query: ({ endpoint, method, params }) => ({
        url: `/myGarage/Seller/LiveInAuction`,
        method: method || "GET",
        params: params || {},
        // body: payload
      }),
    }),
    getLiveAuctionVehicles: builder.query({
      query: ({ endpoint, method, params }) => ({
        url: `/myGarage/Dealer/NewCarsToBids`,
        method: method || "GET",
        params: params || {},
        // body: payload
      }),
    }),
    getBidHistory: builder.query({
      query: ({ vehicleId }) => {
        return {
          url: `/bidhistory/${vehicleId}`,
        };
      },
    }),
    getAuctionHistoryDealer: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/dealer/previousBidHistory/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    getVehicleMakes: builder.query({
      query: ({ endpoint, method }) => {
        return {
          url: endpoint,
          method: "GET",
        };
      },
    }),
    getVehicleModels: builder.mutation({
      query: ({ endpoint, method, payload }) => {
        return {
          url: endpoint,
          method: method || "POST",
          body: payload,
        };
      },
    }),
    getTimeoutDetails: builder.query({
      query: ({ vehicleId }) => {
        return {
          url: `/timeoutdetails/${vehicleId}`
        }
      }
    })
  }),
});

export const {
  useSetDealerBidPriceMutation,
  useCancelAuctionMutation,
  useGetLiveAuctionVehiclesQuery,
  useGetOwnLiveAuctionVehiclesQuery,
  useGetBidHistoryQuery,
  useGetVehicleMakesQuery,
  useGetVehicleModelsMutation,
  useGetTimeoutDetailsQuery
} = liveAuctionApi;

export const {
  useLazyGetBidHistoryQuery,
  useLazyGetLiveAuctionVehiclesQuery,
  useLazyGetOwnLiveAuctionVehiclesQuery,
  useLazyGetVehicleMakesQuery,
  useLazyGetTimeoutDetailsQuery,
  useLazyGetAuctionHistoryDealerQuery
} = liveAuctionApi;
